import Vue from 'vue'
import Navigation from './components/navigation-component.vue'
import Footer from './components/footer-component.vue'
import CMSBar from './components/cms-bar-component.vue'
import router from './routes'
import store from './store'
import VueRouter from 'vue-router'
import Plugins from './plugins'
import VueAnalytics from 'vue-analytics'
import VueLazyload from 'vue-lazyload'
import VueHead from 'vue-head'
import MyConstants from './constants';
import _isUndefined from 'lodash/isUndefined'
import { TimelineMax } from 'gsap/TweenMax'
import VeeValidate from 'vee-validate'
import 'simplebar/dist/simplebar.css';

import vueScrollto from 'vue-scrollto'


Vue.use(vueScrollto, {
	duration: 500,
	offset: -80,
})

Vue.use(VueHead)
Vue.use(VueRouter)
Vue.use(Plugins)
Vue.use(MyConstants)
Vue.use(VeeValidate)
Vue.use(VueLazyload, {
	preLoad: 1.3,
	attempt: 3,
	lazyComponent: true
  })
Vue.use(VueAnalytics, {
	id: 'UA-XXXXXXX-XX',
	router
})   

window.axios = require('axios')

new Vue({
	el: '#app',
	router,
	store,
	data () {
		return {
			sections: []
		}
	},
	template: `
	<div id="app" v-if="sections.length">
		<cms-bar></cms-bar>
		<navigation :sections="sections"></navigation>
		<transition v-on:enter="enter" v-on:leave="leave" v-on:before-enter="beforeEnter" appear mode="out-in">
			<router-view :key="$route.params.sectionSlug"></router-view>
		</transition>
		<footer-component></footer-component>
	</div>`,
	components: {
		cmsBar: CMSBar,
		navigation: Navigation,
		footerComponent: Footer
	},
	created: function () {
		document.title = 'Ashenden Finance'
		if (_isUndefined(this.$route.params.locale)) {
			this.$router.push('/fr/accueil')
		}
		this.getData()
	},
	watch: {
		'$route': function(val) {
			$('html > body').removeClass('popup-extra-info')
		}
	},
	methods: {
		getData () {
			var self = this
			axios.all([this.getSections(), this.getPages(), this.getTweets(), this.getTestimonials()])
				.then(axios.spread((sections, pages, tweets, testimonials) => {
					self.sections = sections.data
					self.$store.commit('sections', sections.data)
					self.$store.commit('pages', pages.data)
					self.$store.commit('tweets', tweets.data)
					self.$store.commit('testimonials', testimonials.data)
				}));
		},
		getSections () {
			return axios.get(`/${this.$route.params.locale}/api/v2/sections`)
		},
		getPages() {
			return axios.get(`/${this.$route.params.locale}/api/v2/pages`)
		},
		getTweets() {
			return axios.get(`/${this.$route.params.locale}/api/v2/tweets`)
		},
		getTestimonials () {
			return axios.get(`/${this.$route.params.locale}/api/v2/testimonials`)
		},
		beforeEnter: function (el) {
			window.scrollTo(0,0)
		},
		enter: function (el, done) {
			let tl = new TimelineMax({onComplete: done})
			this.$nextTick(function () {
				tl
					.set(el,{opacity: 0})
					.to(el, 0.2, {opacity: 1}, 0.2)
			})
		},
		leave: function (el, done) {
			let tl = new TimelineMax({onComplete: done})
				tl
				.to(el, 0.1, {opacity: 0}, 0.1)
		}
	}
})
